module.exports = __webpack_public_path__ + "static/media/frc-christmas-image-3.61ae02c3.jpg";